import { useEffect, useState } from "react";
import Carousel from "./Carousel";

const ResponsiveCarousel = ({ images, baseURL }) => {
    const [visibleCount, setVisibleCount] = useState(3);

    useEffect(() => {
        const update = () => {
            const w = window.innerWidth;
            if (w < 600) setVisibleCount(1);
            else if (w < 900) setVisibleCount(2);
            else setVisibleCount(3);
        };
        update();
        window.addEventListener("resize", update);
        return () => window.removeEventListener("resize", update);
    }, []);

    return (
        <Carousel
            images={images}
            baseURL={baseURL}
            visibleCount={visibleCount}
            scrollSpeed={0.7}
        />
    );
};

export default ResponsiveCarousel;
